// @ts-nocheck
import AssignmentForm from "./requiredForms/assignmentForm";
//---------------------------------------------------
export const locatingItems = [
    {title: "Form Name", type: "text", required: true, docNum: true}, 
    {showTitle: "Proposed Excavation (ft)", title: "White (ft)", type: "number"},
    {showTitle: "Temporary Survey Markings (ft)", title: "Pink (ft)", type: "number"}, 
    {showTitle: "Electric Power Lines (ft)", title: "Red (ft)", type: "number"},
    {showTitle: "Gas, Oil & Stream (ft)", title: "Yellow (ft)", type: "number"},
    {showTitle: "Communications (Telephone & Cable TV) (ft)", title: "Orange (ft)", type: "number"},
    {showTitle: "Water (ft)", title: "Blue (ft)", type: "number"},
    {showTitle: "Reclaimed Water (ft)", title: "Purple (ft)", type: "number"},
    {showTitle: "Sewer and Storm Drains (ft)", title: "Green (ft)", type: "number"}
];
export default function LocatingForm({
    ...rest
}){
    //--------------------------------------------------------------------------------------------
    
    //--------------------------------------------------------------------------------------------
    return(
        <AssignmentForm
            noPDF
            items = {locatingItems}
            {...rest}
        />
    )    
}